
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
  ><!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE --><path
    fill="currentColor"
    d="M11 13H5v-2h6V5h2v6h6v2h-6v6h-2z"
  /></svg>
</template>

<script>
export default {
  name: 'MaterialSymbolsAdd'
}
</script>